import ToolsFooter from '../ToolsFooter';
import { LoginFormCode } from '../codeHighlights/LoginFormCode';
import NavBarTitle from '../nav/NavBarTitle';

const LoginForm = () => {
  return (
    <>
      <NavBarTitle />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12 col-md-7 mx-auto">
            <form>
              <h2>Login</h2>

              <div className="form-floating">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">Email address</label>
              </div>
              <div className="form-floating mt-3">
                <input
                  type="password"
                  className="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                />
                <label htmlFor="floatingPassword">Password</label>
              </div>

              <div className="form-check text-start my-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="remember-me"
                  id="flexCheckDefault"
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Remember me
                </label>
              </div>
              <div className="d-flex justify-content-start gap-2 mt-5">
                <button className="btn btn-secondary" type="submit">
                  Sign in
                </button>
                <button className="btn btn-light" type="reset">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToolsFooter />
      </div>
      <div className="mt-5">
        <LoginFormCode />
      </div>
    </>
  );
};

export default LoginForm;
